<template>
    <WatsonOrganismHeaderLandingPage
        :title="priceGuide.title"
        :cta-block="ctaBlock"
        :cta-block-overwrite="ctaBlockOverwrite"
        :usps="ctaBlock?.usps"
    >
        <template #visual>
            <WatsonThemeProductGraph
                v-if="!priceGuide.hideGraph"
                :price-guide="priceGuide"
            />
        </template>
    </WatsonOrganismHeaderLandingPage>

    <!-- eslint-disable vue/no-v-html -->
    <div
        v-if="priceGuide"
        v-html="`<script type=&quot;application/ld+json&quot;>${JSON.stringify(structuredData)}</script>`"
    ></div>
</template>

<script setup>
import WatsonOrganismHeaderLandingPage from '@organisms/header-landing-page/watson-organism-header-landing-page.vue';
import WatsonThemeProductGraph from '../product-graph/watson-theme-product-graph.vue';

const props = defineProps({
    priceGuide: {
        type: Object,
        required: true,
    },
    ctaBlock: {
        type: Object,
        required: false,
        default: null,
    },
    ctaBlockOverwrite: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const generateStructuredData = priceGuide => {
    return {
        '@context': 'https://schema.org',
        '@type': 'MonetaryAmount',
        'currency': 'EUR',
        'value': 'Number',
        'minValue': priceGuide.lowPrice,
        'maxValue': priceGuide.highPrice,
    };
};

const structuredData = generateStructuredData(props.priceGuide);
</script>
